import { createContext, useContext, useMemo, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const AdminContext = createContext({ isAdmin: false, editing: false, toggleEditing: () => {} });

export function AdminProvider({ children }) {
  const { user } = useAuth();
  const isAdmin = !!user && user.role === "admin";
  // Admins are always in edit mode by default (per spec). They can hide
  // controls temporarily to preview the public experience via toggleEditing.
  const [editing, setEditing] = useState(true);

  const value = useMemo(
    () => ({
      isAdmin,
      editing: isAdmin && editing,
      toggleEditing: () => setEditing((e) => !e),
    }),
    [isAdmin, editing],
  );

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export const useAdmin = () => useContext(AdminContext);
